import {Component} from '@angular/core';
import {AbstractAction} from './abstract-action';

@Component({
    selector: 'vui-action',
    templateUrl: './action.component.html',
    styleUrls: ['./action.component.scss']
})
export class ActionComponent extends AbstractAction {

}
